var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c(
            "div",
            [
              _c("div", { attrs: { id: "subheader" } }),
              _vm._v(" "),
              _c("div", { attrs: { id: "main-container" } }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { attrs: { id: "container" } }, [
                  _c(
                    "div",
                    { attrs: { id: "list-container" } },
                    _vm._l(_vm.items, function(item) {
                      return _c("item-promocion", {
                        attrs: { id: "list-prod", item: item },
                        on: { setItemPromocion: _vm.setPromo }
                      })
                    })
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "btnContainer" } }, [
                  _c(
                    "button",
                    {
                      attrs: { id: "btnAgregarProducto" },
                      on: { click: _vm.btnAgregarProducto }
                    },
                    [_vm._v("AGREGAR PRODUCTO")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "btnIrCarrito" },
                      on: { click: _vm.btnIrCarrito }
                    },
                    [_vm._v("IR AL CARRITO")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fadePro" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPopup,
                        expression: "showPopup"
                      }
                    ]
                  },
                  [
                    _c("div", { attrs: { id: "back-popup" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { height: "390px" },
                        attrs: { id: "popup" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { id: "popup-btnClose-container" } },
                          [
                            _c("img", {
                              staticStyle: { width: "20px", height: "20px" },
                              attrs: {
                                id: "btnClose",
                                src: "/dist/btnClose.png"
                              },
                              on: { click: _vm.btnCerrarPopup }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { attrs: { id: "popup-titulo" } }, [
                          _vm._v("Promoción")
                        ]),
                        _vm._v(" "),
                        _c("div", { attrs: { id: "popup-container" } }, [
                          _c(
                            "div",
                            { attrs: { id: "popup-image-container" } },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "90%",
                                  height: "90%",
                                  "object-fit": "contain"
                                },
                                attrs: { src: _vm.imagenProducto }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { attrs: { id: "popup-container-text" } }, [
                            _c("p", { attrs: { id: "popup-producto" } }, [
                              _vm._v(_vm._s(_vm.nombrePromo))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { attrs: { id: "popup-descripcion-producto" } },
                              [_vm._v(_vm._s(_vm.descripcionPromo))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  color: "#656E76",
                                  "font-weight": "bold",
                                  "margin-top": "12px"
                                }
                              },
                              [_vm._v(" Contenido: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-top": "2px",
                                  "font-size": "10px",
                                  color: "#656E76",
                                  "font-weight": "normal",
                                  height: "40px",
                                  overflow: "auto"
                                }
                              },
                              [
                                _c(
                                  "ul",
                                  _vm._l(_vm.productos, function(producto) {
                                    return _c("li", [_vm._v(_vm._s(producto))])
                                  })
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { attrs: { id: "popup-precio-unitario" } },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.precioPromo)
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { id: "popup-cantidad-label" } },
                              [_vm._v("CANTIDAD")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cantidadProducto,
                                  expression: "cantidadProducto"
                                }
                              ],
                              class: {
                                popupCantidad: _vm.cantValida,
                                popupCantidadInv: !_vm.cantValida
                              },
                              attrs: { type: "text", value: "1" },
                              domProps: { value: _vm.cantidadProducto },
                              on: {
                                keyup: _vm.updateCantidad,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.cantidadProducto = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.limitePromo,
                                    expression: "limitePromo"
                                  }
                                ],
                                staticStyle: {
                                  "font-size": "9px",
                                  color: "#5C666F"
                                }
                              },
                              [
                                _vm._v(
                                  "(max " +
                                    _vm._s(_vm.limiteMaxCantPromo) +
                                    " packs)"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "span",
                                  { attrs: { id: "popup-subtotal-label" } },
                                  [_vm._v("SUBTOTAL")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "font-size": "15px" },
                                    attrs: { id: "popup-subtotal" }
                                  },
                                  [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            _vm.cantidadProducto *
                                              _vm.precioPromo
                                          )
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { "margin-top": "40px" },
                            attrs: { id: "btnContainerPopup" }
                          },
                          [
                            _c(
                              "button",
                              {
                                attrs: { id: "btnCerrarPopup" },
                                on: { click: _vm.btnCerrarPopup }
                              },
                              [_vm._v("CANCELAR")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                attrs: { id: "btnAgregarPopup" },
                                on: { click: _vm.btnAgregarPopup }
                              },
                              [_vm._v("AGREGAR AL CARRITO")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c(
            "div",
            { staticStyle: { "margin-top": "40px" } },
            [
              _c(
                "div",
                {
                  staticClass: "fv ct",
                  staticStyle: { width: "100vw", height: "100vh" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        width: "100%",
                        height: "4%",
                        background: "#44C7F4",
                        color: "white",
                        font: "size 12px"
                      }
                    },
                    [_vm._v("Combos")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "20px",
                        height: "65%",
                        overflow: "auto"
                      },
                      attrs: { id: "list-container" }
                    },
                    _vm._l(_vm.items, function(item) {
                      return _c("item-promocion", {
                        attrs: { id: "list-prod", item: item },
                        on: { setItemPromocion: _vm.setPromo }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fh cc" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btnMobile",
                        staticStyle: {
                          background: "white",
                          color: "#4969B2",
                          "border-style": "solid",
                          "border-color": "#4969B2"
                        },
                        on: { click: _vm.btnAgregarProducto }
                      },
                      [_vm._v("AGREGAR PRODUCTO")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btnMobile",
                        on: { click: _vm.btnIrCarrito }
                      },
                      [_vm._v("IR AL CARRITO")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fadePro" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPopup,
                        expression: "showPopup"
                      }
                    ],
                    staticStyle: { width: "100vw", height: "100vh" }
                  },
                  [
                    _c("div", { attrs: { id: "back-popup" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { width: "96%", height: "390px" },
                        attrs: { id: "popup" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { id: "popup-btnClose-container" } },
                          [
                            _c("img", {
                              staticStyle: { width: "20px", height: "20px" },
                              attrs: {
                                id: "btnClose",
                                src: "/dist/btnClose.png"
                              },
                              on: { click: _vm.btnCerrarPopup }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { attrs: { id: "popup-titulo" } }, [
                          _vm._v("Promoción")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh lc",
                            staticStyle: { width: "100%", "margin-top": "20px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fh ct",
                                staticStyle: { width: "40%", height: "120px" }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "90%" },
                                  attrs: {
                                    id: "imagenProducto-image",
                                    src: _vm.imagenProducto
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fv ct",
                                staticStyle: { width: "60%", height: "120px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh cc",
                                    staticStyle: {
                                      "font-size": "25px",
                                      color: "#5C666F"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.nombrePromo))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh cc",
                                    staticStyle: {
                                      "font-size": "15px",
                                      color: "#5C666F",
                                      "margin-top": "20px"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.descripcionPromo))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "fh cc",
                                    staticStyle: {
                                      "font-size": "15px",
                                      color: "#5C666F"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Precio: $" +
                                        _vm._s(
                                          _vm._f("formatMoney")(_vm.precioPromo)
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh lc",
                            staticStyle: { width: "100%", height: "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-left": "40px",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("CANTIDAD")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cantidadProducto,
                                  expression: "cantidadProducto"
                                }
                              ],
                              class: {
                                popupCantidad: _vm.cantValida,
                                popupCantidadInv: !_vm.cantValida
                              },
                              attrs: { type: "text", value: "1" },
                              domProps: { value: _vm.cantidadProducto },
                              on: {
                                keyup: _vm.updateCantidad,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.cantidadProducto = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.limitePromo,
                                    expression: "limitePromo"
                                  }
                                ],
                                staticStyle: {
                                  "font-size": "9px",
                                  color: "#5C666F"
                                }
                              },
                              [
                                _vm._v(
                                  "(max " +
                                    _vm._s(_vm.limiteMaxCantPromo) +
                                    " packs)"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh lc",
                            staticStyle: { width: "100%", height: "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-left": "40px",
                                  "font-size": "12px"
                                }
                              },
                              [_vm._v("SUBTOTAL")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: { "font-size": "15px" },
                                attrs: { id: "popup-subtotal" }
                              },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.cantidadProducto * _vm.precioPromo
                                      )
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { attrs: { id: "btnContainerPopup" } }, [
                          _c(
                            "button",
                            {
                              attrs: { id: "btnCerrarPopup" },
                              on: { click: _vm.btnCerrarPopup }
                            },
                            [_vm._v("CANCELAR")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              attrs: { id: "btnAgregarPopup" },
                              on: { click: _vm.btnAgregarPopup }
                            },
                            [_vm._v("AGREGAR AL CARRITO")]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Combos")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a72fee0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a72fee0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/promociones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a72fee0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promociones/promociones.vue
// module chunks = 0